import { TrashIcon } from '@heroicons/react/24/outline'

export default function DeleteSetButton({ mode, phaseType, phaseIndex, exerciseIndex, setIndex, mutateExercise }) {
    if (mode === 'edit' && phaseType === 'straight') {
        return (
            <button
                title="Delete Set"
                // className='text-gray-500 hover:text-gray-400'
                className="h-10 w-10 flex justify-center items-center hover:bg-gray-200"
                onClick={() => mutateExercise('remove-specific-set', phaseIndex, exerciseIndex, setIndex)}
            >
                <TrashIcon className="h-5 pointer-events-none" />
            </button>
        )
    }
}
